export default `#version 300 es
precision mediump float;in vec2 coord;out vec4 fragColor;uniform vec4 foreColor;void main(){fragColor=foreColor;}`